import { Component, AfterViewInit, OnInit } from "@angular/core";
import { MetodosPagoService } from "./services/metodos-pago.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AuthServiceService } from "../account/login/services/auth-service.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
declare let ConektaCheckoutComponents: any;

@Component({
  selector: "app-metodos-pago",
  templateUrl: "./metodos-pago.component.html",
  styleUrls: ["./metodos-pago.component.scss"],
})
export class MetodosPagoComponent implements OnInit, AfterViewInit {
  public metodoPagoForm: FormGroup;

  /**Conekta */
  config = {
    publicKey: "key_BbOnkMuJezM4EjzcqMWrHv6",
    targetIFrame: "conektaComponent",
  };

  callbacks = {
    onCreateTokenSucceeded: (token) => this.agregar(token.id),
    onCreateTokenError: (error) => console.log("Error: ", error),
    onGetInfoSuccess: (event) => console.log(event),
  };
  constructor(
    private toast: ToastrService,
    private metodoServices: MetodosPagoService,
    private fb: FormBuilder,
    private auth: AuthServiceService,
    private router: Router
  ) {}

  agregar(token) {
    //console.log(token);
    this.metodoPagoForm.patchValue({
      Token: token,
    });
    this.metodoServices
      .registrarMetodoPago(this.metodoPagoForm.value)
      .subscribe((result) => {
        // this.toast.success("Método de pago agregado correctamente")
        Swal.fire({
          title: "¡Proceso Exitoso!",
          text: "Método de pago agregado correctamente",
          icon: "success", // Puedes cambiar 'success' por 'error', 'warning', 'info', etc.
          confirmButtonText: "Cerrar",
          onClose: () => {
            this.router.navigateByUrl("/pages/listar-metodo-pago").then(() => {
              location.reload();
            });
          },
        });
      });
    //console.log(this.metodoPagoForm.value, "FORM");
  }

  ngOnInit() {
    this.initForm();
  }
  initForm() {
    this.metodoPagoForm = this.fb.group({
      Type: ["Card"],
      Token: [""],
      IdCustomer: [this.auth.getUser().idCliente],
    });
  }

  ngAfterViewInit() {
    // Esta función se ejecutará después de que la vista se haya cargado por completo.
    //console.log("La vista se ha cargado por completo.");
    ConektaCheckoutComponents.Card({
      config: this.config,
      callbacks: this.callbacks,
    });
  }
}
